/**
 * @name of the cookie we want to set/save
 * @value contained in the cookie
 * @days  until the cookie will expire from now
 * @deprecated avoid using cookies in the application: save data in local storage instead.
 */
export function cookieHelperWrap(document: { cookie: string }) {
  function setCookie(name: string, value: number | string | undefined, days: number) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  /**
   * @name of the cookie we want to get the value
   */
  function getCookie(name: string) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      c = c.trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * @name of the target coookie
   */
  function eraseCookie(name: string) {
    /**
     * By setting the expiration date to the past, it will delete our cookie
     */
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  return {
    setCookie,
    getCookie,
    eraseCookie
  };
}

export default cookieHelperWrap(document);
